import mc1 from './mc1.png';
import mc2 from './mc2.png';
import mc3 from './mc3.png';
import mc4 from './mc4.png';
import mc5 from './mc5.png';
import mc6 from './mc6.png';
import mc7 from './mc7.png';
import mc8 from './mc8.png';
import member_1 from './member_1.png';
import member_2 from './member_2.png';
import member_3 from './member_3.png';
import member_4 from './member_4.png';
import member_5 from './member_5.png';
import member_6 from './member_6.png';
import sbd1 from './sbd1.png';
import sbd2 from './sbd2.png';
import sbd3 from './sbd3.png';
import sbd4 from './sbd4.png';
import tnp1 from './tnp1.png';
import tnp2 from './tnp2.png';
import tnp3 from './tnp3.png';
import tnp4 from './tnp4.png';

export const members = {
  member_1: member_1.src,
  member_2: member_2.src,
  member_3: member_3.src,
  member_4: member_4.src,
  member_5: member_5.src,
  member_6: member_6.src,
  tnp1: tnp1.src,
  tnp2: tnp2.src,
  tnp3: tnp3.src,
  tnp4: tnp4.src,
  sbd1: sbd1.src,
  sbd2: sbd2.src,
  sbd3: sbd3.src,
  sbd4: sbd4.src,
  mc1: mc1.src,
  mc2: mc2.src,
  mc3: mc3.src,
  mc4: mc4.src,
  mc5: mc5.src,
  mc6: mc6.src,
  mc7: mc7.src,
  mc8: mc8.src,
};
